import clsx from 'clsx';
import React, { ReactNode, useCallback } from 'react';

import { getFileIcon } from '@/src/components/common/Elements/Icon/FIleIcons';
import Icon, { ICONS } from '@/src/components/common/Elements/Icon/Icon';
import FileCard from '@/src/components/project/Inbox2/Elements/FileCard/FileCard';
import { InboxEntryFile } from '@/src/components/project/Inbox2/types';
import { cn } from '@/src/util/ui';

type AttachmentItem = {
  file: InboxEntryFile;
  containerClassName?: string;
  children: ReactNode;
  onClick?: (file: InboxEntryFile) => void;
};

const AttachmentItem = ({
  file,
  children,
  onClick,
  containerClassName = null,
}: AttachmentItem) => {
  const icon = !file.isFileSupported
    ? ICONS.unsupported()
    : getFileIcon(file.name);

  const handleClick = useCallback(
    (event: React.MouseEvent) => {
      if (onClick) {
        event.stopPropagation();
        onClick(file);
      }
    },
    [file, onClick]
  );

  return (
    <FileCard
      key={file.id}
      className={cn('tw-justify-center', containerClassName)}
      onClick={handleClick}
    >
      <div
        className={clsx(
          'tw-flex tw-items-center tw-text-cfo-black',
          'group-hover:tw-text-cfo-blue-600 group-hover:tw-cursor-pointer group-hover:tw-font-brandonTextMedium'
        )}
      >
        <Icon
          icon={icon}
          className={clsx('icon--files_card', 'tw-mr-[2px]', 'tw-text-[12px]')}
        />
        <span
          className={clsx(
            'tw-text-cfo-black tw-text-[12px]',
            'group-hover:tw-text-cfo-blue-600'
          )}
        >
          {children}
        </span>
      </div>
    </FileCard>
  );
};

export default AttachmentItem;
